import { useParams, useSearchParams } from 'react-router-dom';
import { TitleProps } from '@picsart/growth-rc/Title';
import { DescriptionProps } from '@picsart/growth-rc/Description';
import { filterStyleDescription } from '../data';
import { capitalize } from '../utils/utils';

function useTitleAndDescription(title: TitleProps, description: DescriptionProps) {
  const [query] = useSearchParams();
  const { page } = useParams();

  const filterStyle = capitalize(query.get('style'));

  const prependFilterStyle = (text: string) => (filterStyle ? `${filterStyle} ${text}` : text);

  let outputTitle = title;
  let outputDescription = description;

  if (page) {
    outputTitle = { ...title, text: prependFilterStyle(title.text) };
    outputDescription = { ...description, text: prependFilterStyle(description.text) };
  } else if (!page && filterStyle) {
    outputTitle = { ...title, text: `${filterStyle} fonts` };
    outputDescription = { ...description, text: `${filterStyle} ${filterStyleDescription}` };
  }

  return { outputTitle, outputDescription };
}

export default useTitleAndDescription;
